'use strict';

export var UniformCookieNames;
(function (UniformCookieNames) {
  UniformCookieNames["Testing"] = "UNIFORM_TRACKER_testing";
  UniformCookieNames["VisitorId"] = "UNIFORM_TRACKER_visitor_id";
  UniformCookieNames["VisitCount"] = "UNIFORM_TRACKER_visit_count";
})(UniformCookieNames || (UniformCookieNames = {}));